import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { Button, Confirm, crudUpdateMany } from 'react-admin';

class BulkUpdateButton extends Component {
    state = {
        isOpen: false,
    }

    handleClick = () => {
        this.setState({ isOpen: true });
    };

    handleConfirm = () => {
        const { basePath, crudUpdateMany, resource, selectedIds, field, value } = this.props;
        const body = {};
        body[field] = value;
        crudUpdateMany(resource, selectedIds, body, basePath);
    };

    handleDialogClose = () => {
        this.setState({ isOpen: false });
    };

    render() {
        return (
            <Fragment>
                <Button label={this.props.label || 'Button'} color={this.props.color || 'primary'} onClick={this.handleClick}>
                    {this.props.icon || <span /> }
                </Button>
                <Confirm
                    isOpen={this.state.isOpen}
                    title="Bulk update"
                    content={<div>Are you sure you want to set "{this.props.field}" to "{this.props.value.toString()}" on these {this.props.selectedIds.length} items?<br /><br />{this.props.selectedIds.map(id => <div>{id}</div>)}</div>}
                    onConfirm={this.handleConfirm}
                    onClose={this.handleDialogClose}
                />
            </Fragment>
        );
    }
}

export default connect(undefined, { crudUpdateMany })(BulkUpdateButton);


// WEBPACK FOOTER //
// ./src/resources/ui/BulkUpdateButton.js